// src/config/env.ts

export const ENV = {
  BUILD_MODE: process.env.NEXT_PUBLIC_BUILD_MODE as 'ssr' | 'ssg',

  GRAPHQL_API: process.env.NEXT_PUBLIC_GRAPHQL_API!,
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL!,
  IMAGE_URL: process.env.NEXT_PUBLIC_IMAGE_URL!,
  DOCUMENT_URL: process.env.NEXT_PUBLIC_DOCUMENT_URL!,
  DOMAIN_URL: process.env.NEXT_PUBLIC_DOMAIN_URL!,
  DASHBOARD_URL: process.env.NEXT_PUBLIC_DASHBOARD_URL!,

  ANDROID_APP_ID: process.env.NEXT_PUBLIC_ANDROID_APP_ID!,
  IPHONE_APP_ID: process.env.NEXT_PUBLIC_IPHONE_APP_ID!,
  HUAWEI_APP_ID: process.env.NEXT_PUBLIC_HUAWEI_APP_ID!,

  SEO_TITLE: process.env.NEXT_PUBLIC_SEO_TITLE!,
  SEO_DESCRIPTION: process.env.NEXT_PUBLIC_SEO_DESCRIPTION!,
  SEO_KEYWORD: process.env.NEXT_PUBLIC_SEO_KEYWORD!,

  FACEBOOK_APPID: process.env.NEXT_PUBLIC_FACEBOOK_APPID!,
  GOOGLE_CLIENTID: process.env.NEXT_PUBLIC_GOOGLE_CLIENTID!,
  GOOGLE_TAG_MANAGER_KEY: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_KEY!,
  GOOGLE_ANALYTICS_KEY: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY!,
  GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!,

  CATEGORY_ID: parseInt(process.env.NEXT_PUBLIC_CATEGORY_ID || '1336', 10),
  SUB_CATEGORY_ID: parseInt(process.env.NEXT_PUBLIC_SUB_CATEGORY_ID || '550', 10),
  REQUEST_SERVICE_CATEGORY_ID: process.env.NEXT_PUBLIC_REQUEST_SERVICE_CATEGORY_ID || '1336',

  THREE_MONTH_DISCOUNT: Number(process.env.NEXT_PUBLIC_THREE_MONTH_DISCOUNT || 5),
  SIX_MONTH_DISCOUNT: Number(process.env.NEXT_PUBLIC_SIX_MONTH_DISCOUNT || 10),
  TWELVE_MONTH_DISCOUNT: Number(process.env.NEXT_PUBLIC_TWELVE_MONTH_DISCOUNT || 15),
  VAT_PERCENT: Number(process.env.NEXT_PUBLIC_VAT_PERCENT || 15),
  GTM_ID: process.env.NEXT_PUBLIC_GTM_ID!
};
